module.exports = __webpack_public_path__ + "img/cu_admission_test_omegle.6fda5ce8.png";